import { AlignValue } from '../types/styles';
export const SUPPORTED_TEMPLATE_VERSIONS = [
    1,
    2, // Composite templates: Carousel
];
export const alignInFlex = (align) => {
    switch (align) {
        case AlignValue.Right:
        case AlignValue.Bottom:
            return 'flex-end';
        case AlignValue.Center:
            return 'center';
        case AlignValue.Left:
        case AlignValue.Top:
        default:
            return 'flex-start';
    }
};
export const isTemplateVersionSupported = (templateVersion) => {
    if (!templateVersion)
        return true;
    return SUPPORTED_TEMPLATE_VERSIONS.includes(Number(templateVersion));
};
